// Copyright TraderEvolution Global LTD. © 2017-2026. All rights reserved.
import { AccountFeature } from '@shared/utils/Account/AccountFeature';
import { BaseCustomTableFormatter } from './BaseCustomTableFormatter';
import { BaseCustomTableFormatterName } from './BaseCustomTableFormatterName';
import { MainWindowManager } from '@front/controls/UtilsClasses/MainWindowManager';
import { TvCopyTradingPanel } from '@front/tradingplatform/Panels/TvCopyTradingPanel';
export class CopyTradingFormatter extends BaseCustomTableFormatter {
    constructor() {
        super(BaseCustomTableFormatterName.CopyTrading, AccountFeature.CopyTrading);
    }
    formatElement(dataFields) {
        const button = document.createElement('button');
        button.innerText = 'Copy trading';
        button.style.border = '1px solid #000000'; // Button border
        button.style.borderRadius = '6px'; // Button border radius
        button.style.fontFamily = '-apple-system,BlinkMacSystemFont,Trebuchet MS,Roboto,Ubuntu,sans-serif'; // #124714 1.
        button.style.fontStyle = 'normal';
        button.style.fontWeight = '400';
        button.style.fontSize = '14px';
        button.style.lineHeight = '17px';
        button.style.color = '#131722'; // Text color
        button.addEventListener('click', (event) => {
            event.stopPropagation();
            this.createCopyTradingPanel();
        });
        return button;
    }
    createCopyTradingPanel() {
        const panel = new TvCopyTradingPanel();
        void panel.set({ showCustomFullscreenCloud: true }); // #124782, #124857
        MainWindowManager.AddControl(panel);
    }
}
